// extracted by mini-css-extract-plugin
module.exports = {"OberloTopTip":"BDKmp","OberloTopTipOne":"_1wzTt","OberloTopTipTwo":"V78KB","OberloTipIcon":"_1pBJh","OberloTipClose":"_3Ts-p"};